import ResultsTable from "./results-table-container";

export default ResultsTable;
